import type { BridgePreviewEnvironmentDef } from './types.js';

export function parsePreviewEnvironmentDefs(servers: unknown): BridgePreviewEnvironmentDef[] {
  const out: BridgePreviewEnvironmentDef[] = [];
  if (!Array.isArray(servers)) return out;
  for (const s of servers) {
    if (!s || typeof s !== 'object') continue;
    const o = s as Record<string, unknown>;
    const environmentId = typeof o.environmentId === 'string' ? o.environmentId : '';
    if (!environmentId) continue;
    const envRaw = o.env;
    const env = Array.isArray(envRaw)
      ? envRaw
          .map((e) => {
            if (!e || typeof e !== 'object') return null;
            const r = e as Record<string, unknown>;
            return {
              name: typeof r.name === 'string' ? r.name : '',
              value: typeof r.value === 'string' ? r.value : '',
            };
          })
          .filter((e): e is { name: string; value: string } => e != null && e.name.length > 0)
      : [];
    const portsRaw = o.ports;
    const ports = Array.isArray(portsRaw)
      ? portsRaw.filter((p): p is number => typeof p === 'number' && Number.isInteger(p) && p > 0 && p < 65536)
      : [];
    out.push({
      environmentId,
      name: typeof o.name === 'string' ? o.name : '',
      command: typeof o.command === 'string' ? o.command : '',
      env,
      ports,
    });
  }
  return out;
}
